export enum AlignFieldType {
  None = 0,
  HorizontalCenter = 1,
  VerticalCenter = 2,
  Left = 3,
  Right = 4,
  Top = 5,
  Bottom = 6,
  SameWidth = 7,
}
